<template>
  <div class="publishEvaluation">
    <div class="publishEvaluation-content">
      <img
        alt=""
        class="back"
        src="@/assets/images/trialProductsList/back.png"
        @click="goBack"
      />
      <div class="evaluation-Bg">
        <div class="evaluation-shop-content">
          <div class="evaluation-shop">
            <img
              :src="this.trialMessage.goodsUrl"
              alt=""
              class="evaluation-shop-img"
            />
            <div class="evaluation-shop-title">
              {{ this.trialMessage.goodsName }}
            </div>
          </div>
          <div class="evaluation-shop-evaluate">
            <div class="evaluation-evaluate-title">商品评价：</div>
            <van-rate
              v-model="trialMessage.goodsScore"
              :icon="scoreStar"
              :void-icon="scoreStarActive"
            />
          </div>
        </div>
        <div class="border"></div>
        <div
          v-if="
            trialMessage.descAspectList &&
            trialMessage.descAspectList.length > 0
          "
          class="evaluation-design"
        >
          <div class="evaluation-design-title">描述维度</div>
          <div class="evaluation-design-subTitle">
            <van-checkbox-group
              v-model="result"
              direction="horizontal"
              @change="toChange"
            >
              <van-checkbox
                v-for="(list, index) in trialMessage.descAspectList"
                :key="index"
                :class="{ tabColor: result.includes(list) }"
                :name="list"
                >{{ list }}
              </van-checkbox>
            </van-checkbox-group>
          </div>
        </div>
        <div class="border"></div>
        <div class="evaluation-comment">
          <van-field
            v-model="message"
            class="icon-pencil"
            maxlength="1000"
            placeholder="点击唤起键盘，测评内容填写100字以上，后续中奖几率更高！"
            rows="8"
            type="textarea"
            @input="handleInput"
          >
          </van-field>
        </div>
        <div v-show="message.length !== 0" class="countNum">
          {{
            message.length >= 1000 ? '最大可输入1000字' : `已输入${countNum}字`
          }}
        </div>
        <div v-if="!uploadFile.fileList.length" :class="{ tabStyle: uploadFile.status }" class="evaluation-upload">
          <!--上传按钮-->
          <template>
            <div class="uploaderImg" @click="handleChooseImage">
              <div class="add-img-icon"><img src="@/assets/images/trialProductsList/xiangji-2@2x.png" alt=""></div>
              <div class="add-img-text">{{uploadFile.detail}}</div>
            </div>
          </template>
        </div>
        <div class="uploadIcon" v-else>
          <div class="icon-img" v-for="(item,index) in uploadFile.contentList" :key="item">
            <img class="img-show" :src="item" alt="" @click="imagesPerviewShow(index)">
            <img class="img-close" src="@/assets/images/trialProductsList/close @2x.png" alt="" @click="handleClose(index)">
          </div>
          <div v-if="uploadFile.fileBase64.length < uploadFile.maxUpload" class="img-upload-show" @click="handleChooseImage">
            <img src="@/assets/images/trialProductsList/xiangji-2@2x.png" alt="">
            <p>可再加 {{uploadFile.maxUpload - uploadFile.fileBase64.length}} 张</p>
          </div>
        </div>
      </div>
      <div
        v-if="
          trialMessage.commentAspectList &&
          trialMessage.commentAspectList.length > 0
        "
        class="evaluation-Score-Bg"
      >
        <div class="evaluation-Score-shopTitle">
          {{ this.trialMessage.goodsName }}
        </div>
        <div class="evaluation-Score">
          <ul>
            <li
              v-for="(item, index) in trialMessage.commentAspectList"
              :key="index"
            >
              <div class="title">{{ item.aspectDesc + ':' }}</div>
              <div class="score">
                <van-rate
                  v-model="item.aspectScore"
                  :icon="scoreStar"
                  :void-icon="scoreStarActive"
                />
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <button class="submit" @click="submit">提交</button>
  </div>
</template>
<script
    src="https://res.wx.qq.com/open/js/jweixin-1.2.0.js"
    type="text/javascript"
></script>
<script>
import { ImagePreview } from 'vant'
import wx from 'weixin-js-sdk'
import API from '@/utils/axiosApi/zeroShoppingApi.js'
import { getCookie, getUserInfo, imgCompress,TestUserAgent } from '@/assets/js/common.js'
import { BuiedPointClick_Fn } from '@/assets/js/BuriedPointEvent.js'
import { uploadIMG } from '@/assets/js/uploadConfig.js'
export default {
  components:{
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  data() {
    return {
      result: [],
      uploadFile: {
        fileList: [],
        fileBase64:[],
        maxUpload: 9,
        detail: '添加图片可以帮助他人更真实的了解测评',
        status: 0, // 默认隐藏 上传为true
        contentList: [], //上传成功返回的https路径
      },
      message: '',
      scoreStarActive: require('@/assets/images/trialProductsList/star@2x.png'), // 评分星星active
      scoreStar: require('@/assets/images/trialProductsList/star-active@2x.png'), // 评分星星
      countNum: 0,
      numShow: false,
      trialMessage: {}, // 商品申请信息
      FilesList: [],
      uploadState: false,
      fileStatus: '',
      fileCompList:[],
      // 是否是ios手机
      isIos: this.TestUserAgent().isios
    }
  },
  mounted() {
    this.id = this.$route.params.id
    this.getTrialShopDetail(this.$route.params.id)
    // console.log(uploadIMG, 'uploadIMG')
    this.uploadIMG(this)
    console.log(
      this.trialMessage.commentAspectList,
      'this.trialMessage.commentAspectList'
    )
  },
  watch: {
    // 侦听是否上传删除 如果9张恢复原样 如果0张 显示多少张
    'uploadFile.fileList': {
      handler(newValue, oldValue) {
        const len = newValue.length
        this.uploadFile.detail =
          (len && `可再加${this.uploadFile.maxUpload - len}张`) ||
          '添加图片可以帮助他人更真实的了解测评'
        this.uploadFile.status = len
      },
      deep: true,
    },
  },
  methods: {
    uploadIMG,
    imgCompress,
    TestUserAgent,
    imagesPerviewShow(index){
      ImagePreview({
        images: this.uploadFile.contentList,
        showIndex: true,
        loop: false,
        startPosition: index
      })
    },
    // 删除对应的上传图片
    handleClose(index){
      this.uploadFile.fileList.splice(index,1)
      this.uploadFile.fileBase64.splice(index,1)
      this.uploadFile.contentList.splice(index,1)
      console.log(this.uploadFile.fileList, 'fileList.leng')
    },
    // 图片上传（微信的js-dk）
    handleChooseImage () {
      if (this.isIos) {
        setTimeout(() => { // 解决问题的重要代码（定时器延时）
          this.fetChooseImage()
        }, 400)
      } else {
        this.fetChooseImage()
      }
    },
    fetChooseImage () {
      // eslint-disable-next-line
      const that = this
      wx.ready(() => { // 解决问题的重要代码（方wx.ready里面）
        wx.chooseImage({//选择图片
          count: 9 - that.uploadFile.fileBase64.length,//限制上传图片的张数
          success: function (res) {
            that.localIdArr = res.localIds
            let index = 0
            if(index < that.localIdArr.length){
              that.handleUploadImage(index,that.localIdArr)
            }
            // that.localIdArr.forEach((item,index)=>{
            //   if(that.uploadFile.fileBase64.length === index)
            // })
          }
        })
      })
    },
    handleUploadImage (index,localIdArr) {
      if (!localIdArr.length) {
        return
      }
      if (index >= localIdArr.length) return;
      const that = this
      console.log(wx, 'localIdArr')
      wx.getLocalImgData({
        localId: localIdArr[index], // 图片的localID
        success: function (res) {
          let localData = res.localData; // localData是图片的base64数据，可以用img标签显示
          console.log(localData.startsWith('data:image'))
          if (!localData.startsWith('data:image')) { // 判断是否有这样的头部
            // 没有则加上头部
            localData = 'data:image/jpeg;base64,' +  localData
          }
          localData = localData.replace(/\r|\n/g, '')
          const URLtoBlob = that.blobToFile(that.dataURLtoBlob(localData),localIdArr[index])
          console.log(URLtoBlob, 'URLtoBlob2')
          const type = ['image/jpeg', 'image/png', 'image/jpg']
          if (!type.includes(URLtoBlob.type)) {
            that.$toast('图片格式错误，请上传jpg、png、jpeg格式的图片')
            return false
            // return false;
          }else {
            if(URLtoBlob.size > 5 * 1000 * 1000){
              that.$toast('图片大小超过限制，请重新上传')
              return false
            }else{
              if(URLtoBlob.size > 1000 * 1000){
                that.imgCompress(URLtoBlob).then(res=>{
                  if(res.size > 1000 * 1000){
                    that.$toast('图片大小超过限制，请重新上传')
                    return false
                  }else{
                    that.toastRef = that.$toast.loading({
                      message: '上传中...',
                      forbidClick: true,
                      duration:0,
                      content: that,
                      overlay: true
                    });
                    that.uploadFile.fileBase64.push({
                      base:localData,
                      id: Math.floor(Math.random() * 100) + 1
                    })
                    that.setUploadFile(res)
                    index++
                    if (index < localIdArr.length) {
                      that.handleUploadImage(index, localIdArr)
                    }
                  }
                })
              }else{
                that.toastRef = that.$toast.loading({
                  message: '上传中...',
                  forbidClick: true,
                  duration:0,
                  content: that,
                  overlay: true
                });
                that.uploadFile.fileBase64.push({
                  base:localData,
                  id: Math.floor(Math.random() * 100) + 1
                })
                console.log(URLtoBlob, 'URLtoBlob')
                that.setUploadFile(URLtoBlob)
                index++
                if (index < localIdArr.length) {
                  that.handleUploadImage(index, localIdArr)
                }
              }

            }
          }
        }
      });
    },
    //1,先将base64转换为blob
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    //2,再将blob转换为file
    blobToFile(theBlob, fileName = 'xmh'){
      theBlob.lastModifiedDate = new Date();  // 文件最后的修改日期
      theBlob.name = fileName;                // 文件名
      const str = theBlob.type.split('/')
      console.log(str, 'theBlob.type')
      return new File([theBlob], `${fileName}+.${str[1]}`, {type: theBlob.type, lastModified: Date.now()});
    },
    // 获取详情接口
    getTrialShopDetail(id) {
      API.getTrialShopDetail({ id, type: 2 }, (res) => {
        console.log(res, 'we--')
        if (res.code === 200) {
          this.trialMessage = res.data
        }
        console.log(
          this.trialMessage.commentAspectList,
          'console.log(this.trialMessage);'
        )
      })
    },
    handleInput(val) {
      for (let i = 0; i < this.result.length; i++) {
        if (val.indexOf(this.result[i]) === -1) {
          this.result.splice(i, 1)
        }
      }
      this.countNum = this.message.replaceAll('\n', '').length
      // console.log(this.countNum,'this.countNum');
    },
    toChange() {
      for (let key of this.result) {
        if (this.message.indexOf(key) === -1) {
          this.message =
            this.message.substr(-1) == '\n' ? this.message : this.message + '\n' // 这个文字 如果有/n 就显示文字 没有 就加个/n
          this.message += key + '：' + '\n'
        }
      }
      console.log(this.message, 'this.countNum')
      this.messageList = this.message.split('\n').filter(Boolean)
      if (this.messageList.length) {
        let checkResultArr = [] // 缓存多选框评价
        let userInputArr = [] //用户输入得评价
        let addValArr = this.trialMessage.descAspectList //获取所有的标签返回值
        this.messageList.forEach((a) => {
          let str = a.split('：').filter(Boolean) // 过滤所有非正常的值
          if (addValArr.indexOf(str[0]) !== -1) {
            // 判断是否是用户输入的
            checkResultArr.push(a)
          } else {
            userInputArr.push(a)
          }
        })
        // 取消选择得值
        checkResultArr = checkResultArr.filter((a) => {
          let str = a.split('：').filter(Boolean)
          if (this.result.indexOf(str[0]) !== -1) {
            return a
          }
        })
        let addMessageArr = checkResultArr.concat(userInputArr)
        this.message = ''
        for (let key of addMessageArr) {
          this.message += key + '\n'
        }
      }
      this.countNum = this.message.replaceAll('\n', '').length
      // this.message = this.trialMessage.descAspectList + "：";
    },
    setUploadFile(file) {
      console.log("%c ***********watch************\n","color:red; font-size: 20px;", file)
      let formdata = new FormData()
      if (file.constructor != Array) {
        formdata.append('files', file)
      } else {
        file.forEach((item) => {
          formdata.append('files', item.file)
        })
      }
      if(this.uploadFile.contentList.length >= 9) return
      console.log(formdata.get('files'), '90909090')
      this.fileStatus = 'uploading'
      this.$http.post(
        '/upload/batchPictureFile',
        {ContentType: 'application/x-www-form-urlencoded', timeout: 600000 },
        formdata,
        (res) => {
          console.log(res, '返回的数据')
          console.log(res.code == '200', '返回的数据')
          this.uploadState = false
          if (res.code == '200') {
            console.log(file, 'res.code')
            this.toastRef && this.toastRef.clear()
            this.uploadFile.fileList.push(file)
            this.uploadFile.contentList = [...this.uploadFile.contentList,...res.data]
            file.status = 'done'
            console.log(this.fileStatus, 'this.fileStatus')
          } else {
            // this.uploadFile.fileList = []
            // this.setIMGPop(file)
            this.uploadFile.fileList.pop()
            this.uploadFile.fileBase64.pop()
            file.status = 'failed'
            this.$toast({
              message: '上传失败，请重新上传图片',
              duration: 2000,
            })
            this.getFileLen()
          }
        },
        (err) => {
          if (err) {
            file.status = 'failed'
            // this.uploadFile.fileList = []
            this.uploadFile.fileList.pop()
            this.uploadFile.fileBase64.pop()
            this.$toast({
              message: '上传失败，请重新上传图片',
              duration: 2000,
            })
            this.getFileLen()
          }
        }
      )
    },
    setIMGPop(file) {
      if (file.constructor != Array) {
        this.uploadFile.fileList.pop()
        this.uploadFile.fileBase64.pop()
      } else {
        file.forEach((item) => {
          this.uploadFile.fileList.pop()
          this.uploadFile.fileBase64.pop()
        })
      }
      // this.uploadFile.fileList
    },
    getFileLen() {
      //   this.uploadFile.fileList  = this.uploadFile.fileList.splice((this.uploadFile.fileList.length - 1),1);
      // this.uploadFile.fileList.pop();
      let len = this.uploadFile.fileList.length
      console.log(len, this.uploadFile.fileList, 'this.uploadFile.fileList')
      this.uploadFile.detail = `可再加${this.uploadFile.maxUpload - len}张`
      console.log(
        len == this.uploadFile.maxUpload,
        len,
        this.uploadFile.maxUpload
      )
      if (len) {
        this.uploadFile.status = len
      } else {
        this.uploadFile.status = len
        this.uploadFile.detail = '添加图片可以帮助他人更真实的了解测评'
      }
    },
    // 返回
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push({ path: '/myTrial' })
      }
    },
    submit() {
      console.log(this.uploadFile.fileList, 'this.uploadFile.fileList')
      const evaluation = {
        goodsId: this.trialMessage.id,
        goodsName: this.trialMessage.goodsName,
        productId: this.trialMessage.productId,
        skuId: this.trialMessage.skuId,
        goodsScore: this.trialMessage.goodsScore,
        crmId: getUserInfo(),
        userUrl: getCookie('xmh_headimgurl'),
        userName: getCookie('xmh_nickname'),
        phone: JSON.parse(localStorage.getItem('userInfo')).mobile,
        goodsUrl: this.trialMessage.goodsUrl,
        commentContent: this.message,
        commentUrl: this.uploadFile.contentList,
        commentScore: this.trialMessage.commentAspectList,
        userLevel: localStorage.getItem('userGrade'),
      }
      console.log(evaluation, '12233-----')
      console.log(
        this.uploadFile.contentList.length,
        this.uploadFile.fileList.length,
        'this.uploadFile'
      )
      if (evaluation.commentContent === '') {
        //文字为空
        this.$toast({
          message: '请输入测评内容',
          duration: 2000,
        })
        return
      }
       // 上传不相等提示
      // if (this.uploadFile.contentList.length != this.uploadFile.fileList.length) {
      //   this.$toast({
      //     message: '正在上传图片,请稍等',
      //     duration: 2000,
      //   })
      //   return
      // }
      if (evaluation.commentUrl.length == 0) {
        // 图片为空
        this.$toast({
          message: '请添加测评图片',
          duration: 2000,
        })
        return
      }
      API.getPublishEvaluation({}, evaluation, (res) => {
        BuiedPointClick_Fn('xmhh5_freetrial_postarticle', {
          is_successful: res.code === 200 ? true : false,
        })
        this.$toast({
          message: res.code === 200 ? '发表成功' : res.message,
          duration: 2000,
        })
        setTimeout(() => {
          this.goBack()
        }, 500)
      })
    },
  },
}
</script>

<style lang="less" scoped>
.publishEvaluation {
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;

  .publishEvaluation-content {
    flex: 1;
    overflow: auto;
    flex-shrink: 0;
    flex-basis: 0;
  }
}



.back {
  width: 17px;
  height: 17px;
  margin: 8px 0px 0px 12px;
}
.uploadIcon{
  display: flex;
  flex-wrap: wrap;
  //justify-content: space-between;
  div{
    width: 58px;
    height: 58px;
    margin-left: 10px;
    margin-top: 10px;
    &:nth-child(1){
      margin-left: 0;
    }
    &:nth-child(6){
      margin-left: 0;
    }
  }
  .icon-img{
    width: 58px;
    height: 58px;
    position: relative;
    .img-show{
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 4px;
    }
    .img-close{
      width: 15px;
      height: 15px;
      position: absolute;
      top: 0;
      right: 0
    }
  }
  .img-upload-show{
    text-align: center;
    border-radius: 4px;
    border: 1px dashed #BDBDBD;
    img{
      width: 32px;
      height: 28px;
      margin-top: 8px;
    }
    p{
      font-size: 10px;
      font-weight: 400;
      //margin-top: 3px;
      color: #999999;
    }
  }
}
.evaluation-Bg {
  width: 333px;
  // min-height: 531px;
  background: #ffffff;
  border-radius: 8px;
  margin: 7px 12px 0px;
  padding: 9px 9px;

  .evaluation-shop-content {
    .evaluation-shop {
      display: flex;

      .evaluation-shop-img {
        width: 66px;
        height: 66px;
        border-radius: 5px;
      }

      .evaluation-shop-title {
        margin: 12px 0px 0px 11px;
        width: 248px;
        height: 44px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        overflow: hidden;
        -webkit-line-clamp: 2;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
    }

    .evaluation-shop-evaluate {
      display: flex;
      align-items: center;

      .evaluation-evaluate-title {
        height: 23px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 23px;
        margin: 12px 0px;
      }

      /deep/ .van-rate {
        .van-rate__item:not(:last-child) {
          padding-right: 8px;
        }

        .van-rate__icon--full {
          width: 21px;
          height: 21px;
          background: linear-gradient(180deg, #fc616b 0%, #fb9095 100%);
          -webkit-background-clip: text;
          color: transparent;
        }
      }
    }
  }

  .border {
    width: 330px;
    height: 1px;
    background-color: #979797;
    margin: 0 auto;
    opacity: 0.15;
  }

  .evaluation-design {
    display: flex;
    margin-top: 12px;

    .evaluation-design-title {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 23px;
      margin-right: 5px;
    }

    .evaluation-design-subTitle {
      flex: 1;
      width: 280px;
      font-size: 12px;
      min-height: 23px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;

      /deep/ .van-checkbox__label {
        margin-left: 0;
        color: #999999;

        img {
          width: 100px;
          height: 100px;
        }
      }

      .van-checkbox {
        padding: 0px 12px;
        border: 1px solid #999;
        border-radius: 13px;
        margin: 0px 0px 9px 5px;
        color: #999999;
      }

      .tabColor {
        border: 1px solid #fc616a;

        /deep/ .van-checkbox__label {
          color: #fc616a;
        }
      }

      /deep/ .van-checkbox__icon {
        display: none;
      }
    }
  }

  .evaluation-comment {
    margin-top: 13px;
    display: flex;

    /deep/ .van-cell {
      padding: 0px;

      .van-field__control {
        height: 176px;
      }
    }

    ::v-deep textarea::-webkit-input-placeholder {
      background: url('../../../assets/images/trialProductsList/pencil@2x.png')
        no-repeat 5px 0px;
      background-origin: content-box;
      text-indent: 30px;
      background-size: 20px 18px;
    }

    /deep/ .van-field__word-limit {
      margin-top: 20px;
      text-align: left;
    }
  }

  .countNum {
    height: 22px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    margin-bottom: 5px;
  }

  .evaluation-upload {
    // height: 66px;
    border-radius: 4px;
    border: 1px dashed #979797;
    padding: 12px 0px;
    text-align: center;
    .uploaderImg{
      //height: 90px;
      .add-img-text{
        font-size: 14px;
        font-weight: 400;
        color: #BDBDBD;
        margin-top: 6px;
      }
    }
    .van-uploader__wrapper {
      flex-wrap: nowrap;
      -webkit-flex-wrap: nowrap;
    }

    /deep/ .van-uploader__input-wrapper {
      text-align: center;
    }

    /deep/ .van-uploader {
      // width: 100%;
      .van-uploader__input-wrapper {
        // flex: 1;
        // width: 58px;
        // height: 58px;
        // border-radius: 4px;
        .van-button--primary {
          background: transparent;
          border: none;
        }
      }
    }

    img {
      width: 50px;
      height: 41px;
    }

    p {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #bdbdbd;
      line-height: 20px;
    }
  }

  .tabStyle {
    border-radius: initial;
    border: none;
    //  padding: 12px 0px;
    text-align: left;

    /deep/ .van-uploader__preview {
      .van-uploader__preview-image {
        width: 58px;
        height: 58px;
        border-radius: 8px;
      }

      .van-uploader__preview-delete {
        width: 15px;
        height: 15px;
        background: transparent;
        border-radius: 50%;
        border: 1px solid #8a8a8a;

        .van-uploader__preview-delete-icon {
          color: #8a8a8a;
          top: -2px;
          right: -2px;
        }

        .van-icon-cross::before {
          font-size: 20px;
        }
      }
    }

    /deep/ .van-uploader__input-wrapper {
      width: 58px;
      height: 58px;
      border-radius: 4px;
      border: 1px dashed #999;

      .van-button--normal {
        padding: 0;
        height: 36px;

        .van-icon__image {
          width: 33px;
          height: 28px;
        }
      }

      p {
        font-size: 10px;
      }
    }
  }
}

.evaluation-Score-Bg {
  width: 319px;
  min-height: 0px;
  background: #ffffff;
  border-radius: 8px;
  margin: 12px auto 0px;
  padding: 16px 16px;

  .evaluation-Score-shopTitle {
    min-height: 23px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 23px;
    text-align: left;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .evaluation-Score {
    margin-top: 4px;

    ul {
      li {
        display: flex;
        text-align: left;
        margin-top: 8px;
        min-height: 20px;

        .title {
          min-width: 60px;
          text-align: right;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }

        .score {
          flex: 1;
          margin-left: 5px;

          /deep/ .van-rate {
            .van-rate__item {
              .van-rate__icon {
                font-size: 18px;
              }
            }
          }
        }
      }
    }
  }
}

.submit {
  margin: 0 auto;
  width: 351px;
  height: 45px;
  background: #fc656f;
  border-radius: 25px;
  outline: none;
  border: none;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
</style>
